import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

import { NgSelectModule } from '@ng-select/ng-select';

import { authRouting } from './auth.routes';

import { SharedModule } from "@shared/shared.module";
import { EmailVerificationComponent } from './email-verification/email-verification.component';
import { ApplicationsComponent } from './applications/applications.component';
import { AuthComponent } from './auth.component';


@NgModule({
    imports: [
        CommonModule,
        TranslateModule,
        ReactiveFormsModule,
        NgSelectModule,
        SharedModule,
        authRouting
    ],
    declarations: [
        AuthComponent,
        EmailVerificationComponent,
        ApplicationsComponent
    ]
})
export class AuthModule { }
